const daasWSG = process.env.REACT_APP_DAAS_WSG_PROXY;
const daasSES = process.env.REACT_APP_DAAS_SES_PROXY;
const nodeFDQN = process.env.REACT_APP_DAAS_WSG;
const REACT_APP_T_MOBILE = process.env.REACT_APP_T_MOBILE?.split(",").find(
  (origin: string) => origin === window.location.origin
);
const logoutEUI = `${process.env.REACT_APP_LOGOUT_ENDPOINT}?client_id=DIGITS_PORTAL&redirect_uri=${REACT_APP_T_MOBILE}/signout&rand=
${Date.parse("" + new Date())}`


// `${process.env?.REACT_APP_LOGOUT_ENDPOINT +
//   "?client_id=DIGITS_PORTAL&redirect_uri=" +
//   REACT_APP_T_MOBILE +
//   "/signout&rand=" +
//   Date.parse("" + new Date()),
console.log(nodeFDQN, daasSES, daasWSG);

let url = {
  userInfo: daasWSG + "phone20/consumerProfile/v1/userinfo",
  permissionInfo: daasWSG + "permissionManagement/v1/user/lines?tmoid=",
  lineManagement: daasWSG + "phone20/lineManagement/v1/lines/type?",
  lineUpdate: daasWSG + "phone20/lineManagement/v1/lines",
  invitationInfo: nodeFDQN + "/permissionManagement/grant",
  lineDelveDetail: daasWSG + "permissionManagement/v1/user/lines?msisdn=",
  removeDelveDetail: nodeFDQN + "/permissionManagement/revoke",
  linePair: daasWSG + "phone20/portal/documentManagement/v1/MSIM/lines/",
  sendEmail: daasWSG + "phone20/mStoreManagement/v1/emails",
  devicesList: daasSES + "ses/customercare/v2/services",
  primaryDevice: daasSES + "ses/customercare/v2/termcondition",
  devices: daasSES + "ses/customercare/v2/devices",
  logout: nodeFDQN + "/logout",
  logoutEUI
};

export default url;
